// import React from "react";

// function DevelopmentApproach() {
//   return (
//     <>
//       <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-8 offset-lg-2">
//               <div className="site-heading text-center">
//                 <h4 className="sub-title">What we do</h4>
//                 <h2 className="title split-text-right split-text-in-right">
//                   Our Development Approach
//                 </h2>
//                 <p>
//                   At Xeer Technology, our development approach sticks to
//                   delivering high-quality, secure, and future-ready NFT wallet
//                   solutions.
//                 </p>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="container">
//           <div className="fade-up-anim ">
//             <div className="row">
//               <div className="col-lg-4 col-md-6 process-two-single">
//                 <div className="services-style-two-item">
//                   <div className="top-info">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/7.png"
//                       alt="Image Not Found"
//                     />
//                     <h4>
//                       <a>Client-Centric Requirement Gathering</a>
//                     </h4>
//                     <p>
//                       We start by understanding the client’s specific needs,
//                       including the blockchain network(s) to support and desired
//                       wallet functionalities.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-lg-4 col-md-6 process-two-single">
//                 <div className="services-style-two-item fade-up-anim">
//                   <div className="top-info">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/5.png"
//                       alt="Image Not Found"
//                     />
//                     <h4>
//                       <a>Designing Architecture</a>
//                     </h4>
//                     <p>
//                       Design a flexible, modular architecture that allows easy
//                       integration with various decentralized applications
//                       (dApps) and NFT marketplaces.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-lg-4 col-md-6 process-two-single">
//                 <div className="services-style-two-item fade-up-anim">
//                   <div className="top-info">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/6.png"
//                       alt="Image Not Found"
//                     />
//                     <h4>
//                       <a>Ongoing Support and Upgrades</a>
//                     </h4>
//                     <p>
//                       Provide continuous post-launch support, regular updates,
//                       and enhancements to keep the wallet aligned with industry
//                       developments and user needs.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div className="row pt-4 justify-content-center">
//               <div className="col-lg-4 col-md-6 process-two-single">
//                 <div className="services-style-two-item">
//                   <div className="top-info">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/7.png"
//                       alt="Image Not Found"
//                     />
//                     <h4>
//                       <a>Agile Development Proces</a>
//                     </h4>
//                     <p>
//                       Utilize agile development methodologies for flexibility
//                       and efficiency, ensuring rapid iteration and adaptability
//                       to client feedback.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-lg-4 col-md-6 process-two-single">
//                 <div className="services-style-two-item fade-up-anim">
//                   <div className="top-info">
//                     <img
//                       src="https://validthemes.net/site-template/robok/assets/img/icon/5.png"
//                       alt="Image Not Found"
//                     />
//                     <h4>
//                       <a>Rigorous Testing</a>
//                     </h4>
//                     <p>
//                       Conduct extensive testing to ensure the wallet's
//                       performance, security, and scalability are optimized
//                       before deployment.
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// }

// export default DevelopmentApproach;

import React from "react";
import {
  FaUsers,
  FaDraftingCompass,
  FaLifeRing,
  FaSyncAlt,
  FaVial,
} from "react-icons/fa";

function DevelopmentApproach() {
  const steps = [
    {
      icon: <FaUsers />,
      title: "Client-Centric Requirement Gathering",
      desc: "We start by understanding the client’s specific needs, including blockchain networks and required wallet functionalities.",
    },
    {
      icon: <FaDraftingCompass />,
      title: "Designing Architecture",
      desc: "We design a flexible, modular architecture for seamless integration with dApps and NFT marketplaces.",
    },
    {
      icon: <FaLifeRing />,
      title: "Ongoing Support and Upgrades",
      desc: "We provide continuous post-launch support, updates, and improvements to keep the wallet future-ready.",
    },
    {
      icon: <FaSyncAlt />,
      title: "Agile Development Process",
      desc: "We use agile methodologies for fast iteration, flexibility, and continuous improvement based on feedback.",
    },
    {
      icon: <FaVial />,
      title: "Rigorous Testing",
      desc: "We perform extensive testing to ensure top-level performance, security, and scalability.",
    },
  ];

  return (
    <div className="services-style-two-area default-padding bg-gray blurry-shape-right-bottom">
      <div className="container">
        {/* Heading */}
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h4 className="sub-title">What we do</h4>
              <h2 className="title">Our Development Approach</h2>
              <p>
                At Xeer Technology, our development approach focuses on
                delivering high-quality, secure, and future-ready NFT wallet
                solutions.
              </p>
            </div>
          </div>
        </div>

        {/* Cards */}
        <div className="row g-4 mt-4 justify-content-center">
          {steps.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="process-card text-center p-4">
                <div className="icon-box mx-auto mb-3">{item.icon}</div>

                <h5>{item.title}</h5>
                <p>{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Styles */}
      <style>{`
        .process-card {
          background: #ffffff;
          border-radius: 20px;
          border: 1px solid #e2e8f0;
          transition: all 0.3s ease;
        }

        .process-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.08);
        }

        .icon-box {
          width: 70px;
          height: 70px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(59,130,246,0.1);
          color: #3b82f6;
          border-radius: 18px;
          font-size: 26px;
          transition: 0.3s;
        }

        .process-card:hover .icon-box {
          background: #3b82f6;
          color: #fff;
          transform: scale(1.1);
        }

        h5 {
          font-size: 18px;
          font-weight: 600;
          margin-bottom: 10px;
          color: #0f172a;
        }

        p {
          font-size: 14px;
          color: #64748b;
          margin: 0;
          line-height: 1.6;
        }
      `}</style>
    </div>
  );
}

export default DevelopmentApproach;
